import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedRow: null,
  formData: {
    pettycash_id: '',
    pettycash_name: '',
    pettycash_description: '',
    pettycash_pic: '',
    pettycash_pic_name: '',
    pettycash_currentbalance: '0.00',
    pettycash_iskasbesar: 0,
    pettycash_createdby: '',
    pettycash_createddate: '',
    pettycash_modifyby: '',
    pettycash_modifydate: '',
    rowid: '',
  },
  dataList: [],
  totalData: 0,
  loading: false,
  error: null,
  loadingMessage: '',
  activeTab: 0,
};

const mst07pettycashSlice = createSlice({
  name: 'mst07pettycash',
  initialState,
  reducers: {
    setSelectedRow: (state, action) => { state.selectedRow = action.payload; },
    setFormData: (state, action) => { state.formData = action.payload; },
    clearFormData: (state) => { state.formData = initialState.formData; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setErrorMsg: (state, action) => { state.error = action.payload; },
    setLoadingMessage: (state, action) => { state.loadingMessage = action.payload; },
    fetchDetailSuccess: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
      state.loading = false;
      state.error = null;
    },
    fetchDetailFailure: (state, action) => { state.loading = false; state.error = action.payload; },
    fetchDetailError: (state, action) => { state.loading = false; state.error = action.payload; },
    updateFormData: (state, action) => {
      state.loading = false;
      state.formData = { ...state.formData, ...action.payload };
    },
    resetState: () => initialState,
    setActiveTab: (state, action) => { state.activeTab = action.payload; },
    clearModuleState: (state) => {
      state.activeTab = 0;
      state.dataList = [];
      state.totalData = 0;
      state.loading = false;
      state.loadingMessage = '';
      state.error = null;
      state.selectedRow = null;
      state.formData = initialState.formData;
    },
    setDataList: (state, action) => { state.dataList = action.payload; },
    setTotalData: (state, action) => { state.totalData = action.payload; },
  },
});

export const { setSelectedRow, setFormData, clearFormData, setLoading, setErrorMsg, setLoadingMessage, fetchDetailSuccess, fetchDetailFailure, fetchDetailError, resetState, updateFormData, setActiveTab, setDataList, setTotalData, clearModuleState } = mst07pettycashSlice.actions;

export default mst07pettycashSlice.reducer;
